
import { makeStyles } from '@material-ui/core/styles';
import {DRAWER_WIDTH} from "../constants";
import sizes from "./sizes";

const drawerWidth = DRAWER_WIDTH;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    overflowY: "auto",
  },
  drawer: {
    flexShrink: 0,
    width: drawerWidth,
    [sizes.down("xxs")]: {
      width: "350px",
  }
  },
  drawerPaper: {
    width: drawerWidth,
    [sizes.down("xxs")]: {
      width: "350px",
  }
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    padding: "0",
    paddingBottom: "10px",
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    [sizes.down("sm")]: {
      paddingBottom: "0px",
  },
    [sizes.down("xxs")]: {
      marginLeft: "-350px",
  }
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  buttons: {
    marginTop: "1rem",
  },
  drawerContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px"
  }
}));

export default useStyles;